import React, { useEffect, useState } from "react";
import Select from "react-select";
import CityServices from "services/CityServices";

const SELECT_ALL_VALUE = "SELECT_ALL";

const SelectAllMultipleCity = ({
  selectedCities = [],
  setSelectedCities,
  onChange,
  name = "city",
  label = "Select Cities",
}) => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCities = async () => {
      setLoading(true);

      try {
        const response = await CityServices.getAllCity();
        console.log(response)

        const cityList = response?.data|| [];

        const options = cityList.map((city) => ({
          value: Number(city.id_city),
          label: city.name,
        }));

        console.log("City options:", options);

        setCities(options);
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCities();
  }, []);

  const normalizedSelectedCities = Array.isArray(selectedCities)
    ? selectedCities.map(Number)
    : [];

  const allCitiesSelected =
    cities.length > 0 &&
    cities.every((city) =>
      normalizedSelectedCities.includes(Number(city.value)),
    );

  const cityOptions = [
    {
      value: SELECT_ALL_VALUE,
      label: allCitiesSelected ? "All Cities Selected" : "Select All Cities",
    },
    ...cities,
  ];

  const selectedOptions = cities.filter((city) =>
    normalizedSelectedCities.includes(Number(city.value)),
  );

  const handleCitySelect = (selectedOptions) => {
    const options = selectedOptions || [];

    const selectAllClicked = options.some(
      (option) => option.value === SELECT_ALL_VALUE,
    );

    let selectedValues;

    if (selectAllClicked) {
      selectedValues = allCitiesSelected
        ? []
        : cities.map((city) => Number(city.value));
    } else {
      selectedValues = options
        .map((option) => Number(option.value))
        .filter((value) => !Number.isNaN(value));
    }

    setSelectedCities(selectedValues);

    if (typeof onChange === "function") {
      onChange(selectedValues);
    }
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "40px",
      borderColor: state.isFocused ? "#0e9f6e" : "#d1d5db",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#0e9f6e",
      },
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
          ? "#e8f5ef"
          : "white",
      color: state.isSelected ? "white" : "#111827",
      cursor: "pointer",
    }),

    multiValue: (base) => ({
      ...base,
      backgroundColor: "#0e9f6e",
    }),

    multiValueLabel: (base) => ({
      ...base,
      color: "white",
    }),

    menuList: (base) => ({
      ...base,
      maxHeight: "200px",
    }),
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-1">{label}</label>

      <Select
        isMulti
        name={name}
        options={cityOptions}
        value={selectedOptions}
        onChange={handleCitySelect}
        placeholder={loading ? "Loading cities..." : "--Choose Cities--"}
        isLoading={loading}
        isSearchable
        isClearable
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        styles={customStyles}
      />
    </div>
  );
};

export default SelectAllMultipleCity;
